import Navbar from './sections/navbar/Navbar';
import Header from './sections/header/Header';
import About from './sections/about/About';
import Resume from './sections/resume/Resume';
import Portfolio from './sections/portfolio/Portfolio';
import Contact from './sections/contact/Contact';
import Footer from './sections/footer/Footer';
import Theme from './theme/Theme';
import { useThemeContext } from './context/theme-context';

const App = () => {
  const {themeState} = useThemeContext();

  return (
    <main className={themeState.theme}>
      <Navbar />
      <Header />
      <About />
      <Resume />
      <Portfolio />
      <Contact />
      <Footer />
      <Theme />
    </main>
  )
}

export default App